module.exports = __webpack_public_path__ + "assets/img/kv-00d85ec4.jpg";